import React from 'react'
import Text from '../../../../../Text'
import styles from './styles.module.css'
import { $background, $layer1, $layer3, $textPrimary, $textSecondary } from '../../../../../../styles/colors/semantics'
import { toSrc } from '../../../../../../utils/imageSrc'

function SpecsTable({ specs, theme }) {
  return (
    <div className={styles.tableWrapper}>
      {
        specs.filter(s => !!s).map((spec, i) => (
          <React.Fragment key={i}>
            <div
              className={styles.row}
              style={{
                background: spec.isItemName
                  ? $layer3[theme]
                  : (i % 2 === 1 ? $background[theme] : $layer1[theme])
              }}
            >
              <div
                className={styles.cell}
                style={{
                  color: spec.isItemName ? $textPrimary[theme] : $textSecondary[theme],
                  textAlign: 'left'
                }}
              >
                <Text type={spec.isItemName ? 'heading-7' : 'regular'}>{spec.name}</Text>
              </div>
              <div
                className={styles.cell}
                style={{
                  color: spec.isItemName ? $textPrimary[theme] : $textPrimary[theme],
                  textAlign: 'right'
                }}
              >
                {
                  !!spec.value && spec.value.split('\n').map(((s, j) => <Text key={s + j} type={spec.isItemName ? 'heading-7' : 'regular'}>{s}</Text>))
                }
              </div>
            </div>
            {spec.imageUrl && (
              <div
                className={styles.imageRow}
                style={{ background: i % 2 === 1 ? $background[theme] : $layer1[theme] }}
              >
                {/* eslint-disable-next-line local-rules/img-requires-dimensions -- faithful port of the former styled.img SpecImage: responsive (width:100%/height:auto) content image, box driven by CSS as pre-migration; fixed dimensions are not applicable (#89) */}
                <img className={styles.specImage} src={toSrc(spec.imageUrl)} alt={spec.name} />
              </div>
            )}
          </React.Fragment>
        ))
      }
    </div>
  )
}

export default SpecsTable
